import { useEffect, useState } from "react";
import { api } from "./lib/api.js";
import ReportePublicado from "./ReportePublicado.jsx";

function separarFechaHora(fechaIso) {
  const fecha = new Date(fechaIso);
  const partesFecha = new Intl.DateTimeFormat("en-CA", {
    year: "numeric", month: "2-digit", day: "2-digit", timeZone: "America/Bogota",
  }).format(fecha);
  const partesHora = new Intl.DateTimeFormat("es-CO", {
    hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "America/Bogota",
  }).format(fecha);
  return { fecha: partesFecha, hora: partesHora };
}

function telefonoDesdeWhatsapp(enlace = "") {
  return enlace.match(/wa\.me\/(\d+)/)?.[1] ?? "";
}

export default function VistaPreviaFlyerPersona({ id, onBack }) {
  const [reporte, setReporte] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let vigente = true;
    api.personas.detalle(id)
      .then((resultado) => { if (vigente) setReporte(resultado); })
      .catch((problema) => { if (vigente) setError(problema.message); });
    return () => { vigente = false; };
  }, [id]);

  if (error) return <main className="flyer-preview-state"><strong>No se pudo cargar el flyer</strong><p>{error}</p><button type="button" onClick={onBack}>Volver al inicio</button></main>;
  if (!reporte) return <main className="flyer-preview-state"><p>Preparando vista previa…</p></main>;

  const { fecha, hora } = separarFechaHora(reporte.ultimaVistaEn);
  const telefonoCompleto = telefonoDesdeWhatsapp(reporte.contacto?.whatsapp);
  const codigoPais = telefonoCompleto.startsWith("57") ? "57" : "";
  const telefono = codigoPais ? telefonoCompleto.slice(2) : telefonoCompleto;
  const datos = {
    ...reporte,
    fechaEvento: fecha,
    horaEvento: hora,
    direccionEvento: [reporte.ciudad, reporte.departamento].filter(Boolean).join(", ") || "Ubicación registrada en el mapa",
    estaturaAproximada: reporte.estaturaAproximada ? String(reporte.estaturaAproximada).replace(".", ",") : "",
  };
  const fotos = (reporte.multimedia ?? []).map((foto) => ({
    ...foto,
    ancho: 0,
    alto: 0,
    url: `/api/personas/${reporte.id}/multimedia/${foto.id}/archivo`,
  }));
  const contacto = { codigoPais, telefono, email: "", nombre: reporte.contacto?.nombre ?? "" };

  return <ReportePublicado soloFlyer variante="persona" resultado={reporte} datos={datos} fotos={fotos} contacto={contacto} onInicio={onBack} />;
}
